module.exports = __webpack_public_path__ + "media/images/icon_shine-564aa60ab0161969eafc8fbd479d1e7f.svg";